import {Nullable} from '../../../../../app/TypeHelpers'
import moment from 'moment'
import {convertToNullableMoment} from '../../../../../components/reservations/helpers/helpers'

export const getFormattedTime = (
    date: Nullable<string>,
    time: string
): string => {
    const dateMoment: Nullable<moment.Moment> = convertToNullableMoment(date, time)
    return (dateMoment) ? dateMoment.format('H時mm分') : ''
}